module.exports = __webpack_public_path__ + "static/img/daili.d41c2878.png";